import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { CardContent, Card, Typography, CardMedia } from '@mui/material';

import FileUploaderBtn from 'src/components/common/FileUploaderBtn';

const useStyles = makeStyles()(theme => ({
  card: {
    width: '200px',
    display: 'inline-block',
    margin: '10px',
  },
  cardContent: {
    height: '3em',
    wordBreak: 'break-word',
    wordWrap: 'normal',
    color: theme.palette.primary.main,
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  media: {
    height: 200,
  },
}));

const MassActionMsgImportTplItem = ({ onFileLoaded }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        {t('smartmessaging.contentEditor.uploadTemplate')}
      </CardContent>
      <CardMedia className={classes.media} src="#">
        <FileUploaderBtn
          selectFileLabel={t('smartmessaging.contentEditor.customTemplate.chooseFile')}
          sendFileLabel={t('smartmessaging.contentEditor.customTemplate.sendFile')}
          cancelLabel={t('smartmessaging.contentEditor.customTemplate.cancel')}
          displayCmp={file => (
            <Typography
              style={{
                wordBreak: 'break-word',
                wordWrap: 'normal',
                padding: '8px',
              }}
            >
              {t('smartmessaging.contentEditor.customTemplate.fileToUpload')}
              <br />
              {file.name}
            </Typography>
          )}
          flex={false}
          onFileChange={(e, pFile) => {
            if (!e && !pFile) {
              return false;
            }
            const file = pFile || e.target.files[0];
            if (!file) {
              return false;
            }
            return true;
          }}
          onSend={file => {
            const reader = new FileReader();
            reader.onload = () => onFileLoaded(reader.result);
            reader.readAsText(file);
          }}
        />
      </CardMedia>
    </Card>
  );
};

MassActionMsgImportTplItem.propTypes = {
  onFileLoaded: PropTypes.func.isRequired,
};

export default MassActionMsgImportTplItem;
